import { render, staticRenderFns } from "./DishDeliveryStatistics.vue?vue&type=template&id=fd228c42&"
import script from "./DishDeliveryStatistics.vue?vue&type=script&lang=js&"
export * from "./DishDeliveryStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports